import { atom } from "recoil";

export const mobileMenuOpenedState = atom<boolean>({
  key: "mobileMenuOpenedState",
  default: false,
});
